import {
  GET_ACADEMY_DATA,
  GET_ANALYTICS_DATA,
  GET_CRM_DATA,
  GET_CRYPTO_DATA,
  GET_DETAIL_EMPLOYEE,
  GET_ECOMMERCE_DATA,
  GET_EMPLOYEE,
  GET_EMPLOYEE_V2,
  GET_HC_DATA,
  GET_KESEJAHTERAAN_PEGAWAI,
  GET_METRICS_DATA,
  GET_PERENCANAAN_PEGAWAI,
  GET_TEKNOLOGI_TERBARU,
  GET_UNIT_KERJA,
  GET_WIDGETS_DATA,
} from 'shared/constants/ActionTypes';

const initialState = {
  analyticsData: null,
  ecommerceData: null,
  crmData: null,
  cryptoData: null,
  metricsData: null,
  widgetsData: null,
  healthCare: null,
  academyData: null,
  kesejahteraanPegawai: null,
  perencanaanPegawai: null,
  teknologiTerbaru: null,
  employee: null,
  employee2: null,
  employeeDetail: null,
  unker: [],
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ANALYTICS_DATA:
      return {
        ...state,
        analyticsData: action.payload,
      };

    case GET_ECOMMERCE_DATA:
      return {
        ...state,
        ecommerceData: action.payload,
      };

    case GET_ACADEMY_DATA:
      return {
        ...state,
        academyData: action.payload,
      };

    case GET_CRM_DATA:
      return {
        ...state,
        crmData: action.payload,
      };

    case GET_CRYPTO_DATA:
      return {
        ...state,
        cryptoData: action.payload,
      };

    case GET_METRICS_DATA:
      return {
        ...state,
        metricsData: action.payload,
      };

    case GET_WIDGETS_DATA:
      return {
        ...state,
        widgetsData: action.payload,
      };

    case GET_HC_DATA:
      return {
        ...state,
        healthCare: action.payload,
      };

    case GET_KESEJAHTERAAN_PEGAWAI:
      return {
        ...state,
        kesejahteraanPegawai: action.payload,
      };

    case GET_PERENCANAAN_PEGAWAI:
      return {
        ...state,
        perencanaanPegawai: action.payload,
      };

    case GET_TEKNOLOGI_TERBARU:
      return {
        ...state,
        teknologiTerbaru: action.payload,
      };

    case GET_EMPLOYEE:
      return {
        ...state,
        employee: action.payload,
      };
    case GET_EMPLOYEE_V2:
      return {
        ...state,
        employee2: action.payload,
      };
    case GET_UNIT_KERJA:
      return {
        ...state,
        unker: action.payload,
      };

    case GET_DETAIL_EMPLOYEE:
      return {
        ...state,
        employeeDetail: action.payload,
      };

    default:
      return state;
  }
};
export default dashboardReducer;
